export const TITULO_CUPOM_PROMOCAO = 'Cupom de desconto'

export const LABEL_CUPOM_PROMOCAO = 'Insira o cupom'

export const ID_CUPOM_PROMOCAO = 'cupom-promocao'

export const TIPO_PROMOCAO_CRIACAO_ASSINATURA = 'CRIACAO_ASSINATURA'

export const TIPO_PROMOCAO_UPGRADE_PLANO = 'UPGRADE_PLANO'

export const TIPO_PROMOCAO_REATIVACAO_ASSINATURA = 'REATIVACAO_ASSINATURA'

export const TIPO_PROMOCAO_RENOVACAO_PLANO = 'RENOVACAO_PLANO'

export const TIPO_DESCONTO_PROMOCAO = 'Desconto'

export const TIPO_ACAO_VARIAVEL_PROMOCAO = 'Ação variável'

export const TIPO_DESCONTO_PROMOCAO_PARA_KIT = {
  'slug': 'KIT',
  'visualizacao': 'Kit'
}

export const TIPO_DESCONTO_PROMOCAO_PARA_FRETE = {
  'slug': 'FRETE',
  'visualizacao': 'Frete'
}

export const TIPO_DESCONTO_PROMOCAO_PARA_FRETE_TODOS = {
  'slug': 'FRETE_TODOS',
  'visualizacao': 'Frete'
}

export const TIPO_DESCONTO_PROMOCAO_PARA_FRETE_PRIMEIRO_KIT = {
  'slug': 'FRETE_1_KIT',
  'visualizacao': 'Frete'
}

export const TIPO_DESCONTO_PROMOCAO_PARA_TOTAL = {
  'slug': 'TOTAL',
  'visualizacao': 'Total'
}

export const TIPOS_DESCONTOS_VISUALIZACAO = {
  [ TIPO_DESCONTO_PROMOCAO_PARA_FRETE.slug ]: TIPO_DESCONTO_PROMOCAO_PARA_FRETE.visualizacao,
  [ TIPO_DESCONTO_PROMOCAO_PARA_FRETE_PRIMEIRO_KIT.slug ]: TIPO_DESCONTO_PROMOCAO_PARA_FRETE_PRIMEIRO_KIT.visualizacao,
  [ TIPO_DESCONTO_PROMOCAO_PARA_FRETE_TODOS.slug ]: TIPO_DESCONTO_PROMOCAO_PARA_FRETE_TODOS.visualizacao,
  [ TIPO_DESCONTO_PROMOCAO_PARA_KIT.slug ]: TIPO_DESCONTO_PROMOCAO_PARA_KIT.visualizacao,
  [ TIPO_DESCONTO_PROMOCAO_PARA_TOTAL.slug ]: TIPO_DESCONTO_PROMOCAO_PARA_TOTAL.visualizacao
}
